import styled from "styled-components";

export const AuthRedirectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  max-width: 440px;
  margin-top: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;

export const InfoIconWrapper = styled.div`
  background: #fef3c7;
  border: 0.5px solid #fde68a;
  width: 51px;
  height: 51px;

  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AuthRedirectHeader = styled.h4`
  font-weight: 600;
  font-size: 16px;

  line-height: 140%;
  letter-spacing: 0px;
  color: #1f2937;
  margin-top: 20px;
  overflow-wrap: anywhere;
`;

export const AuthRedirectInfo = styled.p`
  font-weight: 400;
  font-size: 14px;

  line-height: 140%;
  letter-spacing: 0px;
  color: #374151;
  margin-top: 8px;
  overflow-wrap: anywhere;
`;

export const AuthButtonWrapper = styled.div`
  flex: 1;
  margin-top: 20px;
`;
export const ErrorMOdalWrapper = styled.div`
  position: absolute;
  top: 0px;
`;

export const AgreementContentWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  padding: 0px 12px;
  max-height: 60vh;
  overflow-y: auto;

  font-weight: 400;
  font-size: 14px;
  color: #374151;
  line-height: 140%;
  letter-spacing: 0px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  a {
    color: blue;
  }

  @media (max-width: 768px) {
    margin-top: 24px;
    margin-bottom: 20px;
    padding: 0px 4px;
    max-height: 55vh;
    overflow-wrap: anywhere;
  }
`;

export const AgreementSection = styled.p``;

export const AgreementHeader = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0px;
  padding: 5px 24px 5px 12px;
  color: #1f2937;
  overflow-wrap: anywhere;

  @media (max-width: 768px) {
    padding: 0px 28px 0px 4px;
  }
`;

export const TopLineSeparator = styled.div`
  position: absolute;
  height: 1px;
  background: #e5e7eb;
  width: 100%;
  top: 75px;
  left: 0;

  @media (max-width: 768px) {
    top: 64px;
  }
`;

export const BottomLineSeparator = styled.div`
  position: absolute;
  height: 1px;
  background: #e5e7eb;
  width: 100%;
  bottom: 80px;
  left: 0;

  @media (max-width: 768px) {
    bottom: 72px;
  }
`;

export const AgreementCloseButtonWrapper = styled.div`
  padding: 5px 12px;

  @media (max-width: 768px) {
    padding: 5px 4px;
  }
`;
